
export default function About() {
  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-center">
          {/* Left Image Area */}
          <div className="lg:col-span-3">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/0aa604328110c46661544ad324678c65.jpg"
                alt="METOS DOO NIS Team Workspace"
                className="w-full h-[600px] object-cover"
              />
            </div>
          </div>

          {/* Right Content Area */}
          <div className="lg:col-span-2">
            <div className="inline-block mb-6">
              <span className="text-sm font-medium text-teal-600 uppercase tracking-wider">Who We Are</span>
            </div>
            <h3 className="text-5xl font-bold text-gray-900 leading-tight mb-8">
              Expert Team<br />
              <span className="text-gray-400">/</span> Building Excellence
            </h3>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              At METOS DOO NIS, we combine technical expertise with creative innovation to deliver exceptional iOS applications. Our team specializes in developing secure, high-performance solutions that meet the evolving needs of modern mobile users.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              With years of experience in iOS development, we focus on creating applications that not only function flawlessly but also provide intuitive user experiences. From VPN security solutions to device optimization tools, every product we build reflects our commitment to quality and innovation.
            </p>
            <div className="w-20 h-1 bg-teal-500"></div>
          </div>
        </div>
      </div>
    </section>
  );
}